import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import "./footer.scss";

// The cards grow with their content, but a very long total would still run off
// the page, so past a certain digit count the number steps down a size.
const numSizeClass = (value) => {
  const digits = String(value === null || value === undefined ? "" : value)
    .replace(/[^0-9]/g, "").length;
  if (digits > 15) return "rpf-num rpf-num--xs";
  if (digits > 12) return "rpf-num rpf-num--sm";
  if (digits > 9) return "rpf-num rpf-num--md";
  return "rpf-num";
};

const AmountRow = ({ label, value, prefix, accent }) => (
  <tr>
    <th scope="row" className="rpf-label">
      {label}
    </th>
    <td className={accent ? "rpf-value rpf-value--accent" : "rpf-value"}>
      <span className={numSizeClass(value)} dir="ltr">
        <NumberFormat
          value={value}
          displayType={"text"}
          thousandSeparator={true}
          prefix={prefix}
        />
      </span>
    </td>
  </tr>
);

const FooterOfRent = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            R_kreysayara,
            R_totalID,
            R_waslKrdn,
            R_waslKrdnID,
            R_total,
            R_kreykrekar,
            R_isChecked,
            R_rasidWakildolar,
            R_rasidWakildinar,
            R_WakilQard_isChecked,
            R_dashkan,
            R_kamkrdnawayNrx$,
            R_rasidWakildolarNew,
            R_rasidWakildinarNew,
            R_paraDanID,
            R_paraDan$,
            R_kamkrdnawayNrxID,
            R_dashkanID,
            R_joripara,
            R_frosth,
            FIB, cash
          } = value;
          const isDollar = R_joripara == "دۆلار";
          return (
            <>
              <div dir="rtl" className="rent-print-footer fk">
                <div className="rpf-row">
                  <div className="rpf-spacer" />

                  {R_WakilQard_isChecked == true &&
                  R_frosth == "فرۆشتنی وەکیل" ? (
                    <div className="rpf-card">
                      <table className="rpf-table">
                        <tbody>
                          <AmountRow
                            accent
                            label="قەرزی کۆن"
                            value={
                              isDollar
                                ? Number(R_rasidWakildinarNew)
                                : Number(R_rasidWakildolarNew)
                            }
                            prefix={isDollar ? "IQD" : "$"}
                          />
                          <AmountRow
                            label="قەرزی کۆن"
                            value={
                              isDollar
                                ? Number(R_rasidWakildolar).toFixed(2)
                                : Number(R_rasidWakildinar).toFixed(2)
                            }
                            prefix={isDollar ? "$" : "IQD"}
                          />
                          <AmountRow
                            label="قەرزی نوێ"
                            value={
                              isDollar
                                ? Number.isInteger(Number(R_rasidWakildolarNew))
                                  ? Number(R_rasidWakildolarNew)
                                  : Number(R_rasidWakildolarNew).toFixed(2)
                                : Number.isInteger(Number(R_rasidWakildinarNew))
                                ? Number(R_rasidWakildinarNew)
                                : Number(R_rasidWakildinarNew).toFixed(2)
                            }
                            prefix={isDollar ? "$" : "IQD"}
                          />
                        </tbody>
                      </table>
                    </div>
                  ) : null}

                  <div className="rpf-card rpf-card--totals">
                    <table className="rpf-table">
                      <tbody>
                        <AmountRow
                          accent
                          label="کۆی گشتی"
                          value={isDollar ? R_total : R_totalID}
                          prefix={isDollar ? "$" : "IQD"}
                        />
                        {/* <AmountRow
                          label="کەمکردنەوە"
                          value={isDollar ? R_dashkan : R_dashkanID}
                          prefix={isDollar ? "$" : "IQD"}
                        /> */}
                        <tr>
                          <th scope="row" className="rpf-label">
                            جۆری پارەدان
                          </th>
                          <td className="rpf-value">
                            <span className="rpf-text">
                              {FIB ? "FIB" : cash ? "کاش" : "قەرز"}
                            </span>
                          </td>
                        </tr>
                        <AmountRow
                          label="پارەی دراو"
                          value={isDollar ? R_paraDan$ : R_paraDanID}
                          prefix={isDollar ? "$" : "IQD"}
                        />
                        <AmountRow
                          accent
                          label="پارەی ماوە"
                          value={
                            isDollar
                              ? R_paraDan$ != 0 && R_paraDan$ != ""
                                ? R_waslKrdn()
                                : R_kamkrdnawayNrx$()
                              : R_paraDanID != 0 && R_paraDanID != ""
                              ? R_waslKrdnID()
                              : R_kamkrdnawayNrxID()
                          }
                          prefix={isDollar ? "$" : "IQD"}
                        />
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {/* {R_joripara == "دۆلار" ? (

                    <div className="col-5 tc">
                      <div className="row">
                        <div className="col-3 mb3">
                          {R_isChecked == true ? (
                            <>
                              <h3>
                                <NumberFormat
                                  value={R_kreysayara}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={R_joripara == "دۆلار" ? "$" : "ID"}
                                />
                              </h3>
                              <hr />
                              <h3>
                                <NumberFormat
                                  value={R_kreykrekar}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={R_joripara == "دۆلار" ? "$" : "ID"}
                                />
                              </h3>
                              <hr />
                            </>
                          ) : null}

                  </div>
                </>
              ) : (
                ""
              )}

                    <div className="col-5">
                      <div className="row">
                        <div className="col-3 mb3 tc">
                          {R_isChecked == true ? (
                            <>
                              <h3>
                                <NumberFormat
                                  value={R_kreysayara}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"ID"}
                                />
                              </h3>
                              <hr />
                              <h3>
                                <NumberFormat
                                  value={R_kreykrekar}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"ID"}
                                />
                              </h3>
                              <hr />
                            </>
                          ) : null}

                              <h3>
                                <NumberFormat
                                  value={
                                    Number.isInteger(
                                      Number(R_rasidWakildinarNew)
                                    )
                                      ? Number(R_rasidWakildinarNew)
                                      : Number(R_rasidWakildinarNew).toFixed(2)
                                  }
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"ID"}
                                />
                              </h3>
                              <hr />
                            </>
                          ) : null}
                        </div>
                        <div className="col-9 text-right mb3">
                          {R_isChecked == true ? (
                            <>
                              <h3 className="ml5">:کرێ سەیارە</h3>
                              <hr />
                              <h3 className="ml5">:کرێ کرێکار</h3>
                              <hr />
                            </>
                          ) : null}
                          {R_WakilQard_isChecked == true &&
                          R_frosth == "فرۆشتنی وەکیل" ? (
                            <>
                              <h3 className="ml5">:$ قەرزی کۆن</h3>
                              <hr />
                              <h3 className="ml5">:ID قەرزی کۆن</h3>
                              <hr />
                              <h3 className="ml5">:ID قەرزی نوێ</h3>
                              <hr />
                            </>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )} */}
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default FooterOfRent;
